import { createContext } from 'react';

export interface ErrContextInterface {
    error: string | null;
    setError: React.Dispatch<React.SetStateAction<string | null>>;
}

export const ErrorContext = createContext<ErrContextInterface>({
    error: null,
    setError: () => {},
});
